// 팀 상세보기 공용 포맷터 — 종목별 구력 레벨 / 전적 레벨 / 전적 / 매너 점수
// 여러 화면(PostDetail, TeamDetail, TeamProfile 등)에서 동일하게 사용한다.
//
// ⚠️ running = 피클볼 (DB 저장 key는 running, 라벨만 피클볼)
// ⚠️ level_points 컬럼은 전부 0인 미사용 컬럼이므로 절대 사용하지 않는다.

// 종목별 레벨 명칭 (sports_type → 레벨 라벨)
export const SPORT_LEVEL_LABEL = {
  tennis:      "NTRP",
  soccer:      "티어",
  futsal:      "티어",
  badminton:   "전국 급수",
  basketball:  "숙련도",
  bowling:     "에버리지",
  tabletennis: "부수",
  baseball:    "숙련도",
  golf:        "핸디캡",
  running:     "피클볼 수준", // 피클볼
  billiards:   "급수",
};

// 구력 레벨(종목별 정밀): 예) "NTRP 3.0", "핸디캡 80대", "피클볼 수준 중급", "티어 골드"
// level 값이 없으면 "레벨 미설정"
export function formatSportLevel(sportsType, level) {
  if (!level) return "레벨 미설정";
  const label = SPORT_LEVEL_LABEL[sportsType] || "레벨";
  return `${label} ${level}`;
}

// 전적 레벨: match_record_level(text) 우선, 없으면 match_level(숫자), 둘 다 없거나 0이면 "전적 없음"
export function formatRecordLevel(team) {
  if (team?.match_record_level) return team.match_record_level;
  if (team?.match_level && Number(team.match_level) > 0) return `Lv.${team.match_level}`;
  return "전적 없음";
}

// 전적: "{wins}승 {draws}무 {losses}패"
export function formatRecord(team) {
  return `${team?.wins || 0}승 ${team?.draws || 0}무 ${team?.losses || 0}패`;
}

// 매너 점수: manner_avg가 0이거나 null이면 "아직 평가 없음", 값 있으면 "x.x점"
export function formatManner(team) {
  const v = Number(team?.manner_avg);
  if (!team?.manner_avg || v === 0 || Number.isNaN(v)) return "아직 평가 없음";
  return `${v.toFixed(1)}점`;
}
